module.exports = __webpack_public_path__ + "img/keno_logo_17.b86a7c03.png";